import { Component, Input } from "@angular/core"
import { CommonModule } from "@angular/common"
import { DataLoaderComponent } from "../data-loader/data-loader.component"

@Component({
  selector: "app-loading-spinner",
  standalone: true,
  imports: [CommonModule, DataLoaderComponent],
  templateUrl: "./loading-spinner.component.html",
  styleUrl: "./loading-spinner.component.css",
})
export class LoadingSpinnerComponent {
  @Input() isLoading = false
  @Input() message = "Loading..."
  @Input() size: "small" | "medium" | "large" = "medium"
  @Input() overlay = false
}
